import { type ApiErrorResponse, type PostRedeemByVoucherCodeData } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { voucherApi } from '.';

type UseVoucherQueryParam = {
	voucherCode: string;
};

export const UseVoucherQueryKey = ['redeem-voucher'] as const;

export const useVoucherQuery = () => {
	return useMutation<PostRedeemByVoucherCodeData, AxiosError<ApiErrorResponse>, UseVoucherQueryParam, unknown>({
		mutationFn: async ({ voucherCode }: UseVoucherQueryParam) =>
			(await voucherApi).postRedeemByVoucherCode(voucherCode, {
				customErrorInterceptor: () => true
			}),
		mutationKey: UseVoucherQueryKey
	});
};
